'use strict';
//TODO we need convert this to ES6 as per Standard
const primaryConstants = require('./primary.constants');
const secondaryConstants = require('./secondary.constants');
module.exports = {
    ...primaryConstants,
    ...secondaryConstants,
};
